import { render, staticRenderFns } from "./EmployeeAdminTableControl.vue?vue&type=template&id=6a131126&scoped=true&"
import script from "./EmployeeAdminTableControl.vue?vue&type=script&lang=js&"
export * from "./EmployeeAdminTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a131126",
  null
  
)

export default component.exports